module.exports = __webpack_public_path__ + "69bac05409b673b6b88107d5dd5d242f.png";